import React, { useEffect } from 'react'
import { Locations } from 'EstraSuppliers'
import { useFormikContext } from 'formik'
import { ProfileFormValues } from '../../utils'
import { useLocationFields } from '../useLocationFields'
import { SmartCheckbox } from 'app/components/formik/Checkbox'
import { FormGrid } from 'app/components/shared/FormGrid'
import { SmartInput } from 'app/components/formik/Input'
import { FormGroup } from 'app/components/shared/FormGroup'

interface Props {
  locations: Locations
}
export const SecondaryAddress: React.FC<Props> = ({ locations }) => {
  const { values, setFieldValue, setValues } = useFormikContext<
    ProfileFormValues
  >()
  const { provinceOptions, cityOptions } = useLocationFields(
    locations,
    values.company_secondary_province_id
  )

  // empty data when card is hidden
  useEffect(() => {
    if (!values.fill_company_secondary_address) {
      setValues({
        ...values,
        company_secondary_address_street: '',
        company_secondary_address_number: '',
        company_secondary_postal_code: '',
        company_secondary_province_id: '',
        company_secondary_city_id: '',
      })
    }
  }, [values.fill_company_secondary_address])

  return (
    <>
      <FormGroup>
        <SmartCheckbox name='fill_company_secondary_address'>
          Usare indirizzo per corrispondenza diverso dalla sede legale
        </SmartCheckbox>
      </FormGroup>
      {values.fill_company_secondary_address && (
        <>
          <FormGrid cols={[8, 2, 2]}>
            <SmartInput
              label='Indirizzo corrispondenza'
              name='company_secondary_address_street'
              required
            />
            <SmartInput
              label='Num.'
              name='company_secondary_address_number'
              required
            />
            <SmartInput
              label='CAP'
              name='company_secondary_postal_code'
              required
            />
          </FormGrid>

          <FormGrid cols={[6, 6]}>
            <SmartInput
              type='select'
              label='Provincia'
              name='company_secondary_province_id'
              required
              selectCaretSize='small'
              // reset company city when company province changes
              onChange={() => setFieldValue('company_secondary_city_id', '')}
            >
              <option value={''}>Seleziona</option>
              {provinceOptions.map(province => (
                <option key={province.value} value={province.value}>
                  {province.label}
                </option>
              ))}
            </SmartInput>

            <SmartInput
              type='select'
              label='Comune'
              name='company_secondary_city_id'
              required
              selectCaretSize='small'
              disabled={!cityOptions.length}
            >
              <option value={''}>Seleziona</option>
              {cityOptions.map(city => (
                <option key={city.value} value={city.value}>
                  {city.label}
                </option>
              ))}
            </SmartInput>
          </FormGrid>
        </>
      )}
    </>
  )
}
